import React from "react";
import {
  Box,
  Flex,
  Text,
  useTheme,
  Button,
  Skeleton,
  Icon,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import getAxios from "../../hooks/useAxios";
import Nodata from "../../components/Nodata";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowBackIosNew, MdArrowForwardIos, MdSearch } from "react-icons/md";

function ClickedUsers() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const navigate = useNavigate();

  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");

  const access_token = Cookies.get("x-admin-auth");
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [users, setUsers] = React.useState<any>([]);
  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("adclickeduserpage")) || 1;
  });
  const [totalPages, setTotalPages] = React.useState<number>();
  const [totalUsers, setTotalUsers] = React.useState<number>();
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);

  const getClickedAllUsers = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all users", res.data);
      setUsers(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotalUsers(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing users", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  React.useEffect(() => {
    getClickedAllUsers(`/advertisements/${id}/clicks?page=${pageNumber}`);
  }, [pageNumber]);

  React.useEffect(() => {
    if (totalPages && totalPages === pageNumber) {
      setNextNotAllowed(true);
    } else {
      setNextNotAllowed(false);
    }
  }, [totalPages]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Flex
        sx={{
          margin: "2.5rem 0 2rem 2rem",
          gap: "1rem",
          alignItems: "baseline",
        }}
      >
        <Text
          sx={{
            fontSize: theme.fontSizes.subHeading1,
          }}
        >
          Advertisement clicked user list
        </Text>
        <Flex sx={{ flex: 1, justifyContent: "flex-end" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {totalUsers}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Box sx={{ marginTop: "1rem", paddingX: "2rem", width: "70%" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {users && users.length !== 0 ? (
            <table>
              <thead>
                <tr>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Name
                    </Text>
                  </th>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Mobile
                    </Text>
                  </th>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Actions
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((item: any, index: number) => (
                  <tr>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.user_name}
                      </Text>
                    </td>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.user_mobile}
                      </Text>
                    </td>
                    <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2.8rem",
                          borderRadius: "0.25rem",
                        }}
                      >
                        <Button
                          width="100%"
                          height="3rem"
                          rightIcon={<FaArrowRight />}
                          onClick={() => {
                            navigate({
                              pathname: "/users/details",
                              search: `?id=${item.user_id}`,
                            });
                          }}
                          style={{
                            background: theme.colors.primary.main,
                            color: theme.colors.bg.main,
                          }}
                        >
                          <Text sx={{ fontSize: theme.fontSizes.body }}>
                            {"View Details"}
                          </Text>
                        </Button>
                      </Flex>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Nodata heading="No user list found" />
          )}
        </Skeleton>

        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem(
                          "adclickeduserpage",
                          `${pageNumber - 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem(
                          "adclickeduserpage",
                          `${pageNumber + 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default ClickedUsers;
